// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"bb6605c8","31":"069231dc","81":"0d6246c7","245":"39ff67cc","262":"2cf7c265","277":"50ccecbc","361":"4edafe61","453":"db036399","457":"ccb0abd4","492":"ada0b594","527":"114b8b3a","547":"503f4477","706":"58f4e3ba","772":"18d24603","959":"88512963"}[chunkId] + ".chunk.js";
};